<template>
	<div>
		<waiting v-if="loaded == false" />
		<DesignerList v-if="loaded" :items="items" @modifyItem="modifyItem"> </DesignerList>
	</div>
</template>

<script>
	import { designerAuthStatusTypeCode } from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'DesignerManager',
		props: {},
		data: () => ({
			items: [],
			loaded: false,
		}),
		mounted: async function() {
			this.loadItems();
		},
		methods: {
			async loadItems() {
				// 데이터베이스 변동 여부 확인 :: S
				if (this.unsubscribeItems != null) {
					this.unsubscribeItems();
				}
				this.unsubscribeItems = this.$database.onDesigners(async () => {
					//this.loaded = false;
					this.items = await this.$database.loadDesigners();
					this.loaded = true;
				});
				// 데이터베이스 변동 여부 확인 :: E
			},
			async modifyItem(item) {
				const user = await this.$database.loadUser(item.uid);

				let sendNotification = false;
				if (user.designerAuthStatusType != item.designerAuthStatusType) {
					if (item.designerAuthStatusType != designerAuthStatusTypeCode.authWait.code) {
						sendNotification = true;
					}
				}

				await this.$database.setUser(item.uid, item);

				if (sendNotification) {
					let notification = this.$models.NotificationModel.create();
					notification.createAt = this.$database.currentTimestamp();
					if (item.designerAuthStatusType == designerAuthStatusTypeCode.authComplete.code) {
						notification.message = '디자이너 인증이 승인되었습니다.';
					} else if (item.designerAuthStatusType == designerAuthStatusTypeCode.authReject.code) {
						notification.message = '디자이너 인증이 반려되었습니다.';
					}
					notification.receiverUid = item.uid;
					notification.title = '진담헤어';
					await this.$database.addNotification(notification);

					// TODO : 승인 대상의 알림센터에도 저장 필요
				}
			},
		},
	};
</script>

<style scoped></style>
